import apiHandler from "../core/apiHandler";

const creditNoteLookupApi = apiHandler('credit-note-lookup');
export default creditNoteLookupApi;
